import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

export const getFormattedDateUTC = (): string => {
  const date = new Date()
  const utcDate = utcToZonedTime(date, 'UTC')
  return format(utcDate, 'yyyy-MM-dd HH:mm:ss')
}
